import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

const STRIP_PARAMS = ['gift', 'pid', 'ref', 'page',
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];

@Injectable({ providedIn: 'root' })
export class CanonicalService {
  private doc = inject(DOCUMENT);
  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => this.update(e.urlAfterRedirects));
  }

  /**
   * URL publique absolue d'un chemin du site (même origine que la balise canonique)
   * @param path Chemin commençant par `/`
   * @returns L'URL absolue
   */
  absoluteUrl(path: string): string {
    return this.doc.location.origin + path;
  }

  private update(routerUrl: string): void {
    const origin = this.doc.location.origin;
    const [path, qs] = routerUrl.split('?');
    const params = new URLSearchParams(qs ?? '');
    STRIP_PARAMS.forEach(p => params.delete(p));
    if (path === '/offres-evenements' || path.startsWith('/offres-evenements/')) {
      // Pages éditoriales : aucun paramètre n'en change le contenu
      [ ...params.keys() ].forEach(k => params.delete(k));
    }
    const query = params.toString();
    const href = origin + path + (query ? '?' + query : '');

    let link = this.doc.querySelector<HTMLLinkElement>('link[rel=canonical]');
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }
}
